import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import React, { useState } from 'react';
import AudioMessage from './AudioMessage';
import ImageMessage from './ImageMessage';
import VideoMessage from './VideoMessage';
import { resolveMessageMediaUri } from './resolveMessageMediaUri';

const MessageMedia = ({ message }) => {
   const [openImage, setOpenImage] = useState(null);
   const image = resolveMessageMediaUri({ message, mediaType: 'image' });
   const audio = resolveMessageMediaUri({ message, mediaType: 'audio' });
   const video = resolveMessageMediaUri({ message, mediaType: 'video' });

   return (
      <>
         <ImageMessage src={image} onOpen={setOpenImage} />
         <AudioMessage src={audio} duration={message.duration} />
         <VideoMessage src={video} />
         <Dialog open={Boolean(openImage)} onClose={() => setOpenImage(null)} maxWidth='lg'>
            <div className='chatterbox-image-dialog'>
               <IconButton className='chatterbox-image-close' aria-label='Close image' onClick={() => setOpenImage(null)}>
                  <CloseIcon />
               </IconButton>
               {openImage && <img src={openImage} alt='Message attachment enlarged' />}
            </div>
         </Dialog>
      </>
   );
};

export default MessageMedia;
